import React, { useState, useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { getTokenInfo } from "../../services/auth";
import { logout } from "../../services/auth";
import { verifyPermission } from "../../services/auth";

import LogoImg from "../../assets/image/logo.png";
import AvatarUser from "../../assets/image/avatar_user.png";

import {
  Container,
  LogoContainer,
  NavMenuContainer,
  NavItem,
  MenuContainer,
  Footer,
  UserInfoContainer,
  ButtonLogout,
  LogOutIcon,
  AccessIcon,
  CompaniesIcon,
  HomeIcon,
  ModuleIcon,
  UsersIcon,
  MenuIcon,
  CloseIcon,
  FileManagmenteIcon,
  MailTemplateIcon,
  FormNewIcon,
  MenuArrow,
  SubMenu,
  SubMenuItem,
  StyledSettingIcon,
} from "./styles";
import { Modal, Tooltip } from "antd";
import UserProfileModal from "../UserProfileModal";

interface IProps extends RouteComponentProps<any> {}

const SideMenu: React.FC<IProps> = ({ history }) => {
  const [currentRoute, setCurrentRoute] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isVisibleModal, setIsVisibleModal] = useState<boolean>(false);
  const [expandedSubmenu, setExpandedSubmenu] = useState<number | null>(null);

  const formatPerfil = (perfil?: number) => {
    if (perfil === 1) {
      return "Master";
    }
    if (perfil === 2) {
      return "Full";
    }
    if (perfil === 3) {
      return "Admin";
    }
    if (perfil === 4) {
      return "Proprietário";
    }

    return "Usuário";
  };

  const redirect = () => {
    const link = document.createElement("a");
    link.href = process.env.REACT_APP_WEB_AUTH_URL as string;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    setCurrentRoute(history.location.pathname);

    if (
      currentRoute &&
      !currentRoute.includes("/twygo-users") &&
      !currentRoute.includes("/twygo-courses") &&
      expandedSubmenu === 9
    ) {
      setExpandedSubmenu(null);
    }
  }, [history.location.pathname, currentRoute, expandedSubmenu]);

  const isSamePath = (_path: string): boolean => {
    return _path === currentRoute;
  };

  const isSubmenuPathActive = (submenuItems: any[]): boolean => {
    if (!currentRoute) return false;
    return submenuItems.some((item) => currentRoute.includes(item.path));
  };

  const toggleSubmenu = (menuId: number) => {
    if (expandedSubmenu === menuId) {
      setExpandedSubmenu(null);
    } else {
      setExpandedSubmenu(menuId);
    }
  };

  const handleMenuClick = (menu: any) => {
    if (menu.submenu) {
      if (menu.id === 9) {
        history.push("/twygo-users");
        toggleSubmenu(menu.id);
      } else {
        toggleSubmenu(menu.id);
      }
    } else {
      setIsVisible(false);
    }
  };

  const logOutAut = () => {
    Modal.confirm({
      title: "Tem certeza de que deseja sair?",
      okText: "Sim",
      centered: true,
      okType: "primary",
      cancelText: "Não",
      width: 500,
      async onOk() {
        logout();
        redirect();
      },
    });
  };

  const menus = [
    {
      id: 1,
      label: "Página Inicial",
      path: "/",
      icon: <HomeIcon />,
      permission: null,
    },
    {
      id: 2,
      label: "Usuários",
      path: "/users",
      icon: <UsersIcon />,
      permission: "user.access_permission",
    },
    {
      id: 3,
      label: "Empresas",
      path: "/companies",
      icon: <CompaniesIcon />,
      permission: "company.access_permission",
    },
    {
      id: 4,
      label: "Módulos",
      path: "/modules",
      icon: <ModuleIcon />,
      permission: "module.access_permission",
    },
    {
      id: 5,
      label: "Opções de acesso",
      path: "/access-permission",
      icon: <AccessIcon />,
      permission: "access.access_permission",
    },
    {
      id: 6,
      label: "Gerenciador de Arquivos",
      path: "/files-management",
      icon: <FileManagmenteIcon />,
      permission: "file_management.access_permission",
    },
    {
      id: 7,
      label: "Trainee",
      path: "/trainee",
      icon: <MailTemplateIcon />,
      permission: "trainee.access_permission",
    },
    {
      id: 8,
      label: "Influencer",
      path: "/influencer",
      icon: <FormNewIcon />,
      permission: "influencer.access_permission",
    },
    {
      id: 10,
      label: "Integração Template Track",
      path: "/template-track-users",
      icon: <UsersIcon />,
      permission: "template.access_permission",
    },
    {
      id: 9,
      label: "Integração Twygo",
      path: "/twygo-users",
      icon: <UsersIcon />,
      permission: "twygo.acess_permission",
      submenu: [
        {
          id: 1,
          label: "Usuários",
          path: "/twygo-users",
        },
        {
          id: 2,
          label: "Cursos",
          path: "/twygo-courses",
        },
      ],
    },
  ];

  return (
    <>
      {isVisible ? (
        <CloseIcon onClick={() => setIsVisible(false)} />
      ) : (
        <MenuIcon onClick={() => setIsVisible(true)} />
      )}
      <Container responsive={isVisible}>
        <span className="logout-mobile" onClick={() => logOutAut()}>
          Sair
        </span>
        <LogoContainer>
          <img
            src={LogoImg}
            alt="Logo circular cor preta com bordas brancas escrito Amadelli The Best Açaí"
          />
        </LogoContainer>

        <NavMenuContainer>
          {menus.map((menu) => (
            <>
              {(!menu.permission || verifyPermission(menu.permission)) && (
                <>
                  <MenuContainer onClick={() => handleMenuClick(menu)}>
                    <NavItem
                      to={menu.path}
                      actived={
                        menu.submenu
                          ? isSubmenuPathActive(menu.submenu)
                          : isSamePath(menu.path)
                      }
                    >
                      {menu.icon}
                      <span>{menu.label}</span>
                      {menu.submenu && (
                        <MenuArrow
                          expanded={
                            expandedSubmenu === menu.id ||
                            isSubmenuPathActive(menu.submenu)
                          }
                        />
                      )}
                    </NavItem>
                  </MenuContainer>

                  {menu.submenu &&
                    (expandedSubmenu === menu.id ||
                      isSubmenuPathActive(menu.submenu)) && (
                      <SubMenu>
                        {menu.submenu.map((subItem) => (
                          <SubMenuItem
                            key={subItem.id}
                            to={subItem.path}
                            actived={isSamePath(subItem.path)}
                            onClick={() => setIsVisible(false)}
                          >
                            {subItem.label}
                          </SubMenuItem>
                        ))}
                      </SubMenu>
                    )}
                </>
              )}
            </>
          ))}
        </NavMenuContainer>

        <Footer>
          <span className="perfil">PERFIL</span>
          <UserInfoContainer>
            <img
              src={getTokenInfo()?.image ? getTokenInfo()?.image : AvatarUser}
              alt="Imagem de avatar do usuário"
            />
            <div className="info-user-container">
              <div className="info-user">
                <span className="name-user">{getTokenInfo()?.name}</span>
                <span className="role-user">
                  {formatPerfil(getTokenInfo()?.level)}
                </span>
              </div>
              <Tooltip title="Configurações">
                <StyledSettingIcon
                  isActive={isVisibleModal}
                  onClick={() => setIsVisibleModal(true)}
                />
              </Tooltip>
            </div>
          </UserInfoContainer>

          <ButtonLogout onClick={() => logOutAut()}>
            <LogOutIcon />
            <span>Sair</span>
          </ButtonLogout>
        </Footer>
      </Container>

      <UserProfileModal
        visible={isVisibleModal}
        onClose={() => setIsVisibleModal(false)}
        userData={getTokenInfo()}
      />
    </>
  );
};

export default withRouter(SideMenu);
